import { render, staticRenderFns } from "./BillDetails.vue?vue&type=template&id=77be4720"
import script from "./BillDetails.vue?vue&type=script&lang=ts"
export * from "./BillDetails.vue?vue&type=script&lang=ts"
import style0 from "./BillDetails.vue?vue&type=style&index=0&id=77be4720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports